import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const StrokeAndFillIcon = React.memo(function ({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M14 14H1V1H14V14ZM2 13H13V2H2V13Z" fill={color} />
      <rect x="2" y="2" width="11" height="11" fill={color} fillOpacity="0.4" />
    </svg>
  );
});
